
import IconArrowUpRight from '~/components/icons/IconArrowUpRight.vue';

export default {
  components: { IconArrowUpRight },
  props: {
    smallHeader: {
      type: String,
      required: true
    },
    header: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    text2: {
      type: String,
      required: true
    },
    comment: {
      type: String,
      required: true
    },
    linkOneText: {
      type: String,
      required: true
    },
    linkOne: {
      type: String,
      required: true
    }
  }

};
